import { cn } from "@/lib/utils";
import type { DetailUsecase } from "@/services/navigator/agent-detail-service";

import { DetailSection } from "./detail-parts";

// 유즈케이스 (설계서 slide 47 · 52 · Figma 03-01/03): 카드 수만큼, 한 줄 최대 4개, 카드 높이는 행 단위로 통일, 정량 효과는 카드 안 강조 박스(본문 바로 아래 16, Figma ver.7 위쪽 기준).
// 외부(수요자 · 공급자)는 대상 산업 + 알파벳 마스킹(서버가 만듦), PwC 내부만 실제 고객사명 + 보라 '내부 전용' 태그. 대상 산업이 없으면 그 요소만 숨겨요.

function columnsFor(count: number) {
  if (count <= 1) return "grid-cols-1";
  if (count === 2) return "md:grid-cols-2";
  if (count === 4) return "md:grid-cols-2 xl:grid-cols-4";
  return "md:grid-cols-2 xl:grid-cols-3";
}

export function UsecasesSection({ data }: { data: DetailUsecase[] }) {
  return (
    <DetailSection id="usecases" title="유즈케이스">
      <div className={cn("grid auto-rows-fr gap-6", columnsFor(data.length))}>
        {data.map((u, i) => (
          <article key={i} className="flex flex-col gap-2 rounded-nv-card border border-[#E5E5EB] bg-nv-surface p-5">
            {u.label && (
              <div className="flex items-center gap-[6px]">
                <span className="text-[13px] font-medium leading-[21px] text-nv-text-secondary">{u.label}</span>
                {u.internal_only && <span className="inline-flex h-[15px] items-center rounded-nv-pill bg-nv-purple-subtle px-[6px] text-[11px] font-bold leading-[13px] text-nv-purple">내부 전용</span>}
              </div>
            )}
            <h3 className="break-keep text-[18px] font-medium leading-[26px] text-nv-text-primary">{u.title}</h3>
            {u.content && <p className="mt-2 text-[15px] leading-6 text-nv-text-secondary">{u.content}</p>}
            {u.effect && (
              <div className="mt-2 flex flex-col gap-2 rounded-nv-chip bg-nv-bg-page p-4">
                <span className="text-[12px] font-bold leading-[19px] text-nv-text-primary">정량 효과</span>
                <p className="text-[14px] leading-[22px] text-nv-text-primary">{u.effect}</p>
              </div>
            )}
          </article>
        ))}
      </div>
    </DetailSection>
  );
}
